import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "agents-tab-grid"
}
const _hoisted_2 = {
  key: 1,
  class: "empty",
  style: {"padding":"40px"}
}
const _hoisted_3 = { class: "agents-group-bar" }
const _hoisted_4 = { class: "agb-total" }
const _hoisted_5 = {
  key: 0,
  class: "empty",
  style: {"padding":"40px"}
}
const _hoisted_6 = {
  key: 1,
  class: "agents-tab-grid"
}
const _hoisted_7 = ["disabled", "title", "onClick"]
const _hoisted_8 = { class: "ac-head" }
const _hoisted_9 = ["onMouseenter"]
const _hoisted_10 = ["src", "alt", "onError"]
const _hoisted_11 = { class: "ac-name" }
const _hoisted_12 = {
  key: 0,
  class: "skel skel-sm"
}
const _hoisted_13 = {
  key: 1,
  class: "ac-role-lbl"
}
const _hoisted_14 = {
  key: 0,
  class: "ac-atend-badge"
}
const _hoisted_15 = { class: "ac-body" }
const _hoisted_16 = { class: "ac-stat-row" }
const _hoisted_17 = { class: "ac-stat" }
const _hoisted_18 = {
  class: "ac-stat-v",
  style: {"color":"var(--blue)"}
}
const _hoisted_19 = { class: "ac-stat" }
const _hoisted_20 = {
  class: "ac-stat-v",
  style: {"color":"var(--orange)"}
}
const _hoisted_21 = { class: "ac-stat" }
const _hoisted_22 = {
  class: "ac-stat-v",
  style: {"color":"var(--green)"}
}
const _hoisted_23 = {
  key: 0,
  class: "ac-open-row",
  style: {"background":"rgba(124,58,237,.07)","color":"#7C3AED","margin-bottom":"8px"}
}
const _hoisted_24 = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"width":"13px","height":"13px","flex-shrink":"0"}
}
const _hoisted_25 = { style: {"margin-left":"2px"} }
const _hoisted_26 = { style: {"font-size":"10px","opacity":".65","margin-left":"4px"} }
const _hoisted_27 = {
  key: 1,
  class: "ac-open-row none",
  style: {"margin-bottom":"8px"}
}
const _hoisted_28 = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"width":"13px","height":"13px","flex-shrink":"0"}
}
const _hoisted_29 = { class: "ac-meta" }
const _hoisted_30 = {
  key: 0,
  class: "ac-meta-row"
}
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "ac-meta-row" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "ac-meta-row" }
const _hoisted_35 = {
  key: 2,
  class: "agents-pagination"
}
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "ap-info" }

import { computed, watch, nextTick, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import type { Conversation, AgentStats, PopupData } from '@/types/dashboard'
import { avatarColor, initials, fmtDuration } from '@/composables/useHelpers'
import { profileLabel } from '@/composables/useAdmin'
import { useAdminDB } from '@/composables/useAdminDB'
import { fmtDateTimeSecs } from '@/utils/contactsFormat'
import { useAgentChat } from '@/composables/useAgentChat'
import { useChatRailMode } from '@/composables/useChatRailMode'
import { usePermission } from '@/composables/usePermission'

const PAGE_SIZE = 12
type StatusFilter = 'all' | 'online' | 'busy' | 'offline' | 'atendendo'

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentsTab',
  props: {
    conversations: {},
    allAgents: {},
    agentTeamsMap: {},
    active: { type: Boolean },
    scopeReady: { type: Boolean }
  },
  emits: ["showPopup", "hidePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const db = useAdminDB()
const lastAccessMap = ref<Record<number, number>>({})

// Chat entre agentes a partir do card — mesmo estado de módulo (singleton)
// usado pelo AgentChatDrawer.vue, só disparando openThread() daqui.
const store = useStore()
const myId  = computed<number>(() => store.getters.authUser?.id ?? 0)
const { panelOpen, openThread } = useAgentChat()
const { mode: railMode } = useChatRailMode()
const { can } = usePermission()
// 'agentChat.card' é o botão no card em si (perfis de acesso — Chat entre
// Agentes → "Chat pelo Card do Agente"); 'agentChat.view' também precisa
// estar liberado, senão o AgentChatDrawer.vue nem renderiza (seu próprio
// v-if usa essa mesma permissão) e o clique não abriria nada visível.
const canUseAgentChatCard = computed(() => can('agentChat.card') && can('agentChat.view'))

async function openAgentChat(agent: AgentStats) {
  if (agent.availability !== 'online' || agent.id === myId.value) return
  railMode.value = 'agent'
  panelOpen.value = true
  await openThread(myId.value, agent.id)
}

onMounted(async () => {
  try {
    const rows = await db.loadLastAccess()
    lastAccessMap.value = Object.fromEntries(rows.map(r => [r.user_id, r.last_access]))
  } catch {
    // sem dados de último acesso — cards mostram "Nunca acessou"
  }
})

const agents = computed<AgentStats[]>(() => {
  const map: Record<number, AgentStats> = {}

  // Semente com TODOS os agentes do Chatwoot (mesmo sem conversas)
  props.allAgents.forEach(a => {
    map[a.id] = {
      id:           a.id,
      name:         a.name,
      email:        a.email,
      thumbnail:    a.thumbnail,
      role:         a.role,
      availability: a.availability_status,
      total: 0, open: 0, pending: 0, resolved: 0,
      teams: new Set(),
      resolveSecs: [],
      avgResolve: 0,
      lastAccess: lastAccessMap.value[a.id] ?? null,
    } as AgentStats
  })

  // Acumula stats das conversas
  props.conversations.forEach(c => {
    if (!c.assignee) return
    const a = c.assignee
    if (!map[a.id]) {
      map[a.id] = { ...a, total: 0, open: 0, pending: 0, resolved: 0, teams: new Set(), resolveSecs: [], avgResolve: 0, lastAccess: lastAccessMap.value[a.id] ?? null }
    }
    map[a.id].total++
    if (c.status === 'open')     map[a.id].open++
    if (c.status === 'pending')  map[a.id].pending++
    if (c.status === 'resolved') {
      map[a.id].resolved++
      if (c.resolved_at && c.created_at && c.resolved_at > c.created_at) {
        map[a.id].resolveSecs.push(c.resolved_at - c.created_at)
      }
    }
    if (c.team?.name) map[a.id].teams.add(c.team.name)
    // Atualiza availability se a conversa trouxer dado mais recente
    if (a.availability) map[a.id].availability = a.availability
  })

  const order: Record<string, number> = { online: 0, busy: 1, offline: 2 }
  return Object.values(map)
    .map(a => ({
      ...a,
      avgResolve: a.resolveSecs.length
        ? Math.round(a.resolveSecs.reduce((s, v) => s + v, 0) / a.resolveSecs.length)
        : 0,
    }))
    .sort((a, b) => {
      const ao = order[a.availability] ?? 2, bo = order[b.availability] ?? 2
      return ao !== bo ? ao - bo : b.open - a.open
    })
})

const currentPage = ref(1)

// Filtro clicável da barra de grupos — 'atendendo' cruza com os 3 status de
// presença (online/busy/offline), então fica fora do Record<availability>.
const statusFilter = ref<StatusFilter>('all')
function toggleStatusFilter(status: Exclude<StatusFilter, 'all'>) {
  statusFilter.value = statusFilter.value === status ? 'all' : status
}

const filteredAgents = computed(() => {
  if (statusFilter.value === 'all') return agents.value
  if (statusFilter.value === 'atendendo') return agents.value.filter(a => a.open > 0)
  return agents.value.filter(a => a.availability === statusFilter.value)
})

const totalPages = computed(() => Math.ceil(filteredAgents.value.length / PAGE_SIZE))

const pagedAgents = computed(() => {
  const start = (currentPage.value - 1) * PAGE_SIZE
  return filteredAgents.value.slice(start, start + PAGE_SIZE)
})

const groupCounts = computed(() => {
  let online = 0, busy = 0, offline = 0, atendendo = 0
  agents.value.forEach(a => {
    if (a.availability === 'online') online++
    else if (a.availability === 'busy') busy++
    else offline++
    if (a.open > 0) atendendo++
  })
  return { online, busy, offline, atendendo }
})

watch([agents, statusFilter], () => { currentPage.value = 1 })

const cardRefs: HTMLElement[] = []
function setCardRef(el: HTMLElement | null, i: number) {
  if (el) cardRefs[i] = el
}

// scopeReady entra nas dependências porque a troca do skeleton pro grid real
// (v-if="scopeReady === false" → v-else) pode acontecer DEPOIS de pagedAgents
// já ter mudado de valor — sem isso, o watch dispara com cardRefs ainda vazio
// (template no branch do skeleton) e os cards ficam presos em opacity:0 até
// o usuário trocar de aba e voltar (o que alterna `active` e força o retrigger).
watch([pagedAgents, () => props.active, () => props.scopeReady], async ([, isActive, isScopeReady]) => {
  if (!isActive || isScopeReady === false) return
  await nextTick()
  cardRefs.forEach((card, i) => setTimeout(() => card?.classList.add('in'), i * 45))
})

function dotClass(av: string) {
  return { online: 'acd-online', offline: 'acd-offline', busy: 'acd-busy' }[av] || 'acd-offline'
}
function dotColor(av: string) {
  return { online: 'var(--green)', offline: 'var(--ink-40)', busy: 'var(--orange)' }[av] || 'var(--ink-40)'
}
function availLabel(av: string) {
  return { online: 'Online', offline: 'Offline', busy: 'Ocupado' }[av] || 'Offline'
}
function handleImgError(e: Event, agent: AgentStats) {
  const img = e.target as HTMLImageElement
  const div = document.createElement('div')
  div.className = 'ac-av'
  div.style.background = avatarColor(agent.name)
  div.textContent = initials(agent.name)
  img.replaceWith(div)
}
function onAvatarEnter(agent: AgentStats, e: MouseEvent) {
  emit('showPopup', {
    name:      agent.name,
    role:      profileLabel(agent.id, props.agentTeamsMap?.[agent.id] ?? []),
    email:     agent.email || '',
    thumbnail: agent.thumbnail || '',
    status:    agent.availability || 'offline',
    convs:     agent.total,
    openConvs: agent.open,
    team:      [...agent.teams].join(', ') || null,
  }, e.currentTarget as HTMLElement)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tab-pane agents-tab-pane", { hidden: !__props.active }])
  }, [
    (__props.scopeReady === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (n) => {
            return _createElementVNode("div", {
              key: `skel-${n}`,
              class: "agent-card ac-skel"
            }, [...(_cache[8] || (_cache[8] = [
              _createStaticVNode("<div class=\"ac-head\"><div class=\"skel skel-av\" style=\"width:58px;height:58px;\"></div><div><div class=\"skel skel-md\" style=\"margin-bottom:6px;\"></div><div class=\"skel skel-sm\"></div></div></div><div class=\"ac-body\"><div class=\"ac-stat-row\"><div class=\"ac-stat\"><div class=\"skel skel-sm\" style=\"margin:0 auto;\"></div></div><div class=\"ac-stat\"><div class=\"skel skel-sm\" style=\"margin:0 auto;\"></div></div><div class=\"ac-stat\"><div class=\"skel skel-sm\" style=\"margin:0 auto;\"></div></div></div></div>", 2)
            ]))])
          }), 64))
        ]))
      : (!agents.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.5"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "8",
                r: "4"
              }),
              _createElementVNode("path", { d: "M20 21a8 8 0 1 0-16 0" })
            ], -1),
            _createElementVNode("p", null, "Nenhum agente encontrado", -1),
            _createElementVNode("small", null, "Conversas sem responsável atribuído", -1)
          ]))]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["agb-item agb-online", { active: statusFilter.value === 'online' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleStatusFilter('online')))
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "agb-dot" }, null, -1)),
                _createTextVNode(_toDisplayString(groupCounts.value.online) + " Online ", 1)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["agb-item agb-busy", { active: statusFilter.value === 'busy' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleStatusFilter('busy')))
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "agb-dot" }, null, -1)),
                _createTextVNode(_toDisplayString(groupCounts.value.busy) + " Ocupado ", 1)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["agb-item agb-offline", { active: statusFilter.value === 'offline' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleStatusFilter('offline')))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "agb-dot" }, null, -1)),
                _createTextVNode(_toDisplayString(groupCounts.value.offline) + " Offline ", 1)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["agb-item agb-atendendo", { active: statusFilter.value === 'atendendo' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleStatusFilter('atendendo')))
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "agb-dot" }, null, -1)),
                _createTextVNode(_toDisplayString(groupCounts.value.atendendo) + " Atendendo ", 1)
              ], 2),
              _createElementVNode("span", _hoisted_4, [
                _createTextVNode(_toDisplayString(filteredAgents.value.length), 1),
                (statusFilter.value !== 'all')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" de " + _toDisplayString(agents.value.length), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[14] || (_cache[14] = _createTextVNode(" agentes ", -1))
              ])
            ]),
            (!filteredAgents.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[15] || (_cache[15] = _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.5"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "8",
                      r: "4"
                    }),
                    _createElementVNode("path", { d: "M20 21a8 8 0 1 0-16 0" })
                  ], -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("p", null, "Nenhum agente com esse status", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ap-btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (statusFilter.value = 'all'))
                  }, "Limpar filtro")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedAgents.value, (agent, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: agent.id,
                      class: _normalizeClass(["agent-card", { 'ac-offline': agent.availability === 'offline' }]),
                      ref_for: true,
                      ref: el => setCardRef(el as HTMLElement, i)
                    }, [
                      (canUseAgentChatCard.value && agent.id !== myId.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "ac-chat-btn",
                            disabled: agent.availability !== 'online',
                            title: agent.availability === 'online' ? `Conversar com ${agent.name}` : 'Agente offline',
                            onClick: _withModifiers(($event: any) => (openAgentChat(agent)), ["stop"])
                          }, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" })
                            ], -1)
                          ]))], 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "ac-av-wrap",
                          onMouseenter: ($event: any) => (onAvatarEnter(agent, $event)),
                          onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('hidePopup')))
                        }, [
                          (agent.thumbnail)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: agent.thumbnail,
                                alt: agent.name,
                                class: "ac-av",
                                style: {"width":"58px","height":"58px"},
                                onError: (e) => handleImgError(e, agent)
                              }, null, 40, _hoisted_10))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "ac-av",
                                style: _normalizeStyle({ background: _unref(avatarColor)(agent.name) })
                              }, _toDisplayString(_unref(initials)(agent.name)), 5)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["ac-status-dot", dotClass(agent.availability)])
                          }, null, 2)
                        ], 40, _hoisted_9),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(agent.name), 1),
                          (!__props.agentTeamsMap || !Object.keys(__props.agentTeamsMap).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(profileLabel)(agent.id, __props.agentTeamsMap?.[agent.id] ?? [])), 1))
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["ac-avail-badge", agent.availability])
                        }, [
                          _createElementVNode("span", {
                            class: "ac-bdot",
                            style: _normalizeStyle({ background: dotColor(agent.availability) })
                          }, null, 4),
                          _createTextVNode(" " + _toDisplayString(availLabel(agent.availability)), 1)
                        ], 2),
                        (agent.open > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("svg", {
                                width: "10",
                                height: "10",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.5",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
                                _createElementVNode("path", { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
                              ], -1),
                              _createTextVNode(" em atendimento ", -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(agent.open), 1),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "ac-stat-l" }, "Abertas", -1))
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(agent.pending), 1),
                            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "ac-stat-l" }, "Pendente", -1))
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(agent.resolved), 1),
                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "ac-stat-l" }, "Resolv.", -1))
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["ac-open-row", agent.open > 0 ? 'has' : 'none'])
                        }, [
                          _cache[22] || (_cache[22] = _createElementVNode("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(agent.open > 0 ? `${agent.open} conversa${agent.open > 1 ? 's' : ''} aberta${agent.open > 1 ? 's' : ''}` : 'Sem chats abertos'), 1)
                        ], 2),
                        (agent.avgResolve > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("circle", {
                                  cx: "12",
                                  cy: "12",
                                  r: "10"
                                }, null, -1),
                                _createElementVNode("polyline", { points: "12 6 12 12 16 14" }, null, -1)
                              ]))])),
                              _cache[24] || (_cache[24] = _createTextVNode(" TMR: ", -1)),
                              _createElementVNode("strong", _hoisted_25, _toDisplayString(_unref(fmtDuration)(agent.avgResolve)), 1),
                              _createElementVNode("span", _hoisted_26, "(" + _toDisplayString(agent.resolveSecs.length) + " resolv.)", 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (_openBlock(), _createElementBlock("svg", _hoisted_28, [...(_cache[25] || (_cache[25] = [
                                _createElementVNode("circle", {
                                  cx: "12",
                                  cy: "12",
                                  r: "10"
                                }, null, -1),
                                _createElementVNode("polyline", { points: "12 6 12 12 16 14" }, null, -1)
                              ]))])),
                              _cache[26] || (_cache[26] = _createTextVNode(" TMR: sem dados ", -1))
                            ])),
                        _createElementVNode("div", _hoisted_29, [
                          (agent.email)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _cache[27] || (_cache[27] = _createElementVNode("svg", {
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2"
                                }, [
                                  _createElementVNode("path", { d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" }),
                                  _createElementVNode("polyline", { points: "22,6 12,13 2,6" })
                                ], -1)),
                                _createElementVNode("span", {
                                  title: agent.email
                                }, _toDisplayString(agent.email), 9, _hoisted_31)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_32, [
                            _cache[28] || (_cache[28] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"9\" cy=\"7\" r=\"4\"></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"></path></svg>", 1)),
                            _createElementVNode("span", {
                              title: [...agent.teams].join(', ') || '—'
                            }, _toDisplayString([...agent.teams].join(', ') || '—'), 9, _hoisted_33)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _cache[29] || (_cache[29] = _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\"><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\"></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\"></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\"></line></svg>", 1)),
                            _createElementVNode("span", null, _toDisplayString(agent.lastAccess !== null ? _unref(fmtDateTimeSecs)(agent.lastAccess) : 'Nunca acessou'), 1)
                          ])
                        ])
                      ])
                    ], 2))
                  }), 128))
                ])),
            (totalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("button", {
                    class: "ap-btn",
                    disabled: currentPage.value <= 1,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (currentPage.value--)),
                    title: "Página anterior"
                  }, [...(_cache[30] || (_cache[30] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                    ], -1)
                  ]))], 8, _hoisted_36),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p,
                      class: _normalizeClass(["ap-btn ap-page", { active: p === currentPage.value }]),
                      onClick: ($event: any) => (currentPage.value = p)
                    }, _toDisplayString(p), 11, _hoisted_37))
                  }), 128)),
                  _createElementVNode("button", {
                    class: "ap-btn",
                    disabled: currentPage.value >= totalPages.value,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (currentPage.value++)),
                    title: "Próxima página"
                  }, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
                    ], -1)
                  ]))], 8, _hoisted_38),
                  _createElementVNode("span", _hoisted_39, _toDisplayString((currentPage.value - 1) * PAGE_SIZE + 1) + "–" + _toDisplayString(Math.min(currentPage.value * PAGE_SIZE, filteredAgents.value.length)) + " de " + _toDisplayString(filteredAgents.value.length), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
  ], 2))
}
}

})